import { useState } from "react";

const InputText = ({
  label,
  name = "",
  errorMessage = "",
  secondaryLabel = "",
  validator = () => { return true; },
  onChange = () => { },
  ...rest
}) => {
  const [showError, setShowError] = useState(false);

  const handelChange = (e) => {

    e.target.placeholder = " ";
    e.target.classList.remove("input-error")
    const labelTag = e.target.nextElementSibling;
    if (labelTag && labelTag.classList.contains("span-md")) {
      labelTag.classList.remove("label-error");
    }

    if (!validator(e.target.value)) {
      labelTag.textContent = label;
      setShowError(true);
    } else {
      if (secondaryLabel && secondaryLabel !== "")
        labelTag.textContent = secondaryLabel;
      setShowError(false);
    }
    onChange(e);
  }

  return (
    <label className="label-md">
      <input
        type="text"
        name={name}
        className="input-md"
        placeholder=" "
        onChange={handelChange}
        {...rest}
      />
      <span className="span-md">{label}</span>
      {showError && <span className="span-error">{errorMessage}</span>}
    </label>
  );
};

export default InputText;
